import type { TranslationKey } from "../locales";
import type { AutoIntegrationListItem } from "../types";

/**
 * This function is used to get the translation key of the auto integration list item's state.
 * @param state
 * @returns
 */
export function getIntegrationStateTranslationKey(
	state: AutoIntegrationListItem<unknown>["state"],
): TranslationKey {
	switch (state) {
		case "both":
			return "integrations.state_both";
		case "external":
			return "integrations.state_external";
		case "internal":
			return "integrations.state_internal";
	}
}
